/**
 * Step Mixin
 */
import submitLoans from '@/mixins/submit/submit-loans'
import navigation from '@/mixins/navigation'

export default {
  // Mixins
  mixins: [navigation, submitLoans],

  props: {
    skipUpdateLead: {
      type: Boolean,
      default: false
    }
  },

  // Methods
  methods: {
    $_step_handleContinue (data, dataLayerObject) {
      if (this.skipUpdateLead) return this.$_navigation_handleNext(dataLayerObject)

      return this.$_loans_updateLead(data, dataLayerObject)
    }
  }
}
